/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Тип заявляемого изображения. Где W - словесный, D - изобразительный, C - комбинированный.
 * @export
 * @enum {string}
 */
export enum ImageSignType {
  C = 'C',
  D = 'D',
  W = 'W',
}

export function instanceOfImageSignType(value: any): boolean {
  for (const key in ImageSignType) {
    if (Object.prototype.hasOwnProperty.call(ImageSignType, key)) {
      if (ImageSignType[key as keyof typeof ImageSignType] === value) {
        return true
      }
    }
  }
  return false
}

export function ImageSignTypeFromJSON(json: any): ImageSignType {
  return ImageSignTypeFromJSONTyped(json, false)
}

export function ImageSignTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ImageSignType {
  return json as ImageSignType
}

export function ImageSignTypeToJSON(value?: ImageSignType | null): any {
  return value as any
}
